import http from "./axios";
import qs from "qs";

let service = http();
// get 请求
export default function httpDelete({ url, params = {}, config = {} }) {
  return new Promise((resolve, reject) => {
    console.log(params);
    service
      .delete(url, {
        data: params,
        ...config
      })
      .then(res => {
        resolve(res?.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
